import { Component, OnInit, ViewChild,ElementRef  } from '@angular/core';
import { DatePipe } from '@angular/common'
import { ReportService } from '../../_service/report.service';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
@Component({
  selector: 'app-treatment-wise-report',
  templateUrl: './treatment-wise-report.component.html',
  styleUrls: ['./treatment-wise-report.component.css']
})
export class TreatmentWiseReportComponent implements OnInit {
  start_date:string='';end_date:string='';allUsers=[];loading:boolean=false;loaded:boolean=false;myrole:string;userId:any;
  circle:string;circles=[];
  TreatmentLeads=[];TreatmentOpds=[];TreatmentIpds=[];TreatmentList=[];
  constructor(private leadapi:LeadsService,private reportapi:ReportService,private sharedapi:SharedService,public datepipe: DatePipe) { }

  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
  ngOnInit(): void 
  {
      this.sharedapi.getRole()
      .subscribe((item:string) => {this.myrole=item;});
      this.myrole = localStorage.getItem('role');
      this.userId = localStorage.getItem('loginuserId');
      
      if(this.myrole=='1' || this.userId=='3')
      {
          this.getcircle();
          this.getTreatmentWiseReport();
      }
      
  }

  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      this.getTreatmentWiseReport();
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
          this.getTreatmentWiseReport();
      }
  }
  
  

  async getTreatmentWiseReport()
  {
    if(this.myrole=='1' || this.myrole=='3')
    {
          this.loaded = false;
          let qString = 'circle='+this.circle+'&date_range='+this.start_date+'-'+this.end_date;
          this.loading = true;
          await this.reportapi.getTreatmentWiseReport(qString).subscribe((data:any) => {
              this.loaded = true;
              this.loading = false;
              if(data.status)
              {
                this.TreatmentList = data.TreatmentList;
                this.TreatmentLeads = data.TreatmentLeads;
                this.TreatmentOpds = data.TreatmentOpds;
                this.TreatmentIpds = data.TreatmentIpds;
                
                this.TreatmentList.forEach(e1 => {
                  e1.opdCount = 0; e1.ipdCount = 0;e1.leadCount = 0;
                  let leadData = this.TreatmentLeads.find(lead=>lead.id==e1.id)
                  if(leadData) e1.leadCount = leadData.lead_total_count;

                  let opdData = this.TreatmentOpds.find(opd=>opd.id==e1.id)
                  
                  if(opdData) e1.opdCount = opdData.opd_total_count;

                  let ipdData = this.TreatmentIpds.find(ipd=>ipd.id==e1.id)
                  if(ipdData) e1.ipdCount = ipdData.ipd_total_count;
                  
                });
           
              }
          }, error => {
              this.loading = false;
              this.sharedapi.checkError(error);
          });
    }     
  }

  async getcircle()
  {
      await this.leadapi.getcircles().subscribe((data:any) => {
          if(data.status)
          {
              this.circles = data.data;
          }else{
              this.circles = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

}